"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CountryLanguage = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../../Elements/Icon/Icon");
var _CountryFlag = require("./CountryFlag");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-props-no-spreading */

/**
 * UI component for login button within main navigation
 */
const CountryLanguage = ({
  countryCode,
  languages,
  active,
  onClick,
  languageText,
  changeCountryText,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
  className: `ccl__country-language ${active ? 'ccl__country-language--active' : ''}`,
  ...props,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
    type: "button",
    className: "ccl__country-language__button",
    onClick: onClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CountryFlag.CountryFlag, {
      countryCode: countryCode
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "ccl__country-language__button__text",
      children: languageText
    }), languages.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      type: "expand-more",
      color: "primary",
      rotate: active ? '180' : '',
      size: "sm"
    })]
  }), languages.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
    className: "ccl__country-language__list",
    children: [languages.map(language => /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
      className: "ccl__country-language__list__item",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("a", {
        href: "/",
        className: "ccl__country-language__list__item__link",
        type: "button",
        onClick: () => {},
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CountryFlag.CountryFlag, {
          countryCode: language.countryCode
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "ccl__country-language__list__item__text",
          children: language.languageText
        })]
      })
    }, language.languageText)), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
      className: "ccl__country-language__list__item",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        className: "ccl__country-language__list__item__button",
        type: "button",
        onClick: () => {},
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          type: "public",
          color: "secondary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "ccl__country-language__list__item__text",
          children: changeCountryText
        })]
      })
    })]
  })]
});
exports.CountryLanguage = CountryLanguage;
CountryLanguage.defaultProps = {
  onClick: () => {},
  changeCountryText: 'Other country/region'
};